import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Terminal, ArrowRight } from "lucide-react";

export default function Register() {
    const { register, error } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        const ok = await register(name, email, password);
        setBusy(false);
        if (ok) navigate("/app/tunnels");
    };

    return (
        <div className="min-h-screen bg-[#050505] flex">
            <div className="hidden lg:flex w-1/2 border-r border-[#27272A] flex-col p-12 justify-between">
                <Link to="/" className="flex items-center gap-2" data-testid="register-logo">
                    <Terminal className="w-5 h-5 text-[#00FF41]" strokeWidth={2.5} />
                    <span className="font-display text-xl uppercase tracking-tight font-bold">SYNAPSELINK</span>
                </Link>
                <div className="space-y-3 max-w-md">
                    <div className="label-mono text-[#00FF41]">// account/init</div>
                    <h1 className="heading-lg">PROVISION YOUR FIRST URL.</h1>
                    <p className="text-[#A1A1AA]">Free tier includes one persistent subdomain, the live inspector, password protect, and the full CLI.</p>
                </div>
                <pre className="text-[#52525B] text-xs leading-snug font-mono">{`▸ allocating workspace ......... ok
▸ generating api key ........... ok
▸ assigning relay region ....... ok
▸ writing inspector schema ..... ok
▸ ready`}</pre>
            </div>

            <div className="flex-1 flex items-center justify-center px-6 py-10">
                <div className="w-full max-w-md">
                    <div className="label-mono text-[#00FF41] mb-3">// CREATE ACCOUNT</div>
                    <h2 className="heading-md mb-8">CLAIM YOUR HANDLE_</h2>
                    <form onSubmit={submit} className="space-y-7" data-testid="register-form">
                        <div className="relative">
                            <span className="absolute left-0 top-2.5 text-[#52525B]">{">"}</span>
                            <input className="tf-input" placeholder="Ada Lovelace" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name-input" />
                            <div className="label-mono mt-1">FULL NAME</div>
                        </div>
                        <div className="relative">
                            <span className="absolute left-0 top-2.5 text-[#52525B]">{">"}</span>
                            <input className="tf-input" placeholder="email@example.com" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email-input" />
                            <div className="label-mono mt-1">EMAIL</div>
                        </div>
                        <div className="relative">
                            <span className="absolute left-0 top-2.5 text-[#52525B]">{">"}</span>
                            <input className="tf-input" placeholder="min 6 chars" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password-input" />
                            <div className="label-mono mt-1">PASSWORD</div>
                        </div>
                        {error && <div className="text-[#FF3B30] text-sm font-mono" data-testid="register-error">[ ERR ] {error}</div>}
                        <button disabled={busy} className="tf-btn w-full justify-center" data-testid="register-submit-btn">
                            {busy ? "PROVISIONING..." : "CREATE ACCOUNT"} <ArrowRight className="w-4 h-4" />
                        </button>
                    </form>
                    <div className="mt-8 text-sm text-[#A1A1AA]">
                        Already have an account? <Link to="/login" className="text-[#00FF41] hover:underline" data-testid="register-to-login-link">Login →</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
